export const LOGIN_API =
  "https://hidocdr.com/api/HidocDrConsultant/login/adminLogin";

export const GET_ANALYTICS =
  "https://hidocdr.com/api/HidocDrConsultant/admin/getAnalytics";

export const GET_SPECIALIST_LIST =
  "https://prodapi.hidoc.co:8443/HidocDrConsultant/admin/getSpecialistsList";

export const GET_HCP_LIST =
  "https://hidocdr.com/api/HidocDrConsultant/admin/getHcpsList";
